import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  Inject,
  inject,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {
  MatTableModule,
  MatRow,
  MatTableDataSource,
} from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';

import { DialogService } from '../../services/dialogservice';
import { NotificationService } from '../../services/notificationservice';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MarketService } from '../../services/marketservice';
import { MarketList } from '../../models/market.model';
import { MarketmDialogComponent } from './market-dilaog/market-dialog.component';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../shared/components/confirmation-dialog/confirmation-dialog.component';
import { RolePermissionsService } from '../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../interfaces/securityPermissions';
import { RoleService } from '../../services/role.service';

@Component({
  selector: 'app-markets',
  imports: [
    MatIcon,
    MatTableModule,
    MatRow,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    CommonModule,
  ],
  templateUrl: './markets.component.html',
  styleUrl: './markets.component.scss',
})
export class MarketsComponent {
  //fsLoadlist: FeedstockLoadScheduleList | undefined;
  filterText: string = '';
  permissions = inject(RolePermissionsService);
  displayedColumns: string[] = ['actions', 'regionName'];
  dataSource = new MatTableDataSource<any>();

  marketList: MarketList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Output('onFormSubmit') formEmitter = new EventEmitter<any>();
  isDataLoaded = false;
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
  constructor(
    private _dialog: MatDialog,
    private marketService: MarketService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private rolesService: RoleService
  ) {}
  ngOnInit(): void {
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.Markets, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
    this.getMarkets();
  }

  getMarkets() {
    this.isDataLoaded = false;
    this.marketService.getMarketList().subscribe({
      next: (res: MarketList[]) => {
        this.marketList = res;
        if (this.isDataLoaded == false) {
        }
        this.isDataLoaded = true;

        this.dataSource = new MatTableDataSource(this.marketList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.syncFilter();
      },
      // error: (err: HttpErrorResponse) => {
      //   console.log(err);
      //   this.notificationService.show(err.message,'error');
      //   this.isDataLoaded = true
      // }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterText = filterValue; // Store the current text
    this.syncFilter();
  }
  syncFilter() {
    if (this.dataSource) {
      this.dataSource.filter = this.filterText.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }
  openContextmenu(data: any, action: any) {
    if (action == 'EDIT') {
      this.openMarketForm(false, data);
    } else if (action == 'DELETE') {
      console.log('delte record ', data);
      this.deleteMarketRecord(data);
    }
  }

  deleteMarketRecord(data: MarketList) {
  const dialogData: ConfirmationDialogData = {
    title: 'Confirm Deletion',
    message: `Are you sure you want to delete market "${data.regionName}"?`,
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    confirmButtonColor: 'warn'
  };

  const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
    width: '500px',
    panelClass: 'delete-confirmation-dialog',
    data: dialogData
  });

  dialogRef.afterClosed().subscribe((result) => {    
    if (result === true) {
      this.handleDeleteMarketRecord(data.id);
    }
  });
}


  handleDeleteMarketRecord(id: any) {
    this.marketService.deleteMarket(id).subscribe({
      next: (response: any) => {
        //this.dialogRef.close(true);
        this.formEmitter.emit({ submit: true });
        this.notificationService.show('Market deleted successfully', 'success');
        this.getMarkets();
      },
      // error: (err: any) => {
      //   console.error('Error deleting market:', err);
      // },
    });
  }

  openMarketForm(isAdd?: any, formData?: any): void {
    const dialogRef = this._dialog.open(MarketmDialogComponent, {
      width: '500px',
      data: {
        title: isAdd ? 'Add Market' : 'Edit Market',
        formData: isAdd ? {} : formData || {},
        isAddForm: isAdd || false,
        canSave: this.controlPermissions.addButton || this.controlPermissions.edit
      }, // Pass your input data object here
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      if (result?.submitted && result.data) {
        console.log('Data received:', result.data);
        this.getMarkets();
      } else {
        console.log('Dialog cancelled or no data returned.');
      }
    });
  }
}
